"use client";

import { c as _c } from "react/compiler-runtime";
import { getTimeAgoShort } from "@/helpers/Helpers";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import { DropSize, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { INotificationDropQuoted } from "@/types/feed.types";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import Drop, { DropInteractionParams, DropLocation } from "@/components/waves/drops/Drop";
import { ApiDrop } from "@/generated/models/ApiDrop";
import NotificationHeader from "../subcomponents/NotificationHeader";
import { useWaveNavigation } from "../utils/navigationUtils";
export default function NotificationDropQuoted(t0) {
  const $ = _c(30);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  const {
    navigateToWave
  } = useWaveNavigation();
  let t1;
  if ($[0] !== navigateToWave || $[1] !== notification.related_drops[0].wave) {
    t1 = serialNo => {
      const baseWave = notification.related_drops[0].wave as any;
      const isDirectMessage = baseWave?.chat?.scope?.group?.is_direct_message ?? false;
      navigateToWave(notification.related_drops[0].wave.id, serialNo, isDirectMessage);
    };
    $[0] = navigateToWave;
    $[1] = notification.related_drops[0].wave;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onReplyClick = t1;
  let t2;
  if ($[3] !== navigateToWave) {
    t2 = quote => {
      const quoteWave = quote.wave as any;
      const isDirectMessage_0 = quoteWave?.chat?.scope?.group?.is_direct_message ?? false;
      navigateToWave(quote.wave.id, quote.serial_no, isDirectMessage_0);
    };
    $[3] = navigateToWave;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onQuoteClick = t2;
  const t3 = notification.related_drops[0].author;
  let t4;
  if ($[5] !== notification.related_drops[0].author) {
    t4 = <NotificationsFollowBtn profile={notification.related_drops[0].author} size={UserFollowBtnSize.SMALL} />;
    $[5] = notification.related_drops[0].author;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="tw-text-iron-400 tw-font-normal tw-text-sm">quoted you</span>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-font-bold tw-mr-1 tw-text-xs tw-text-iron-400">•</span>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== notification.created_at) {
    t7 = getTimeAgoShort(notification.created_at);
    $[9] = notification.created_at;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t6}{t7}</span>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== notification.related_drops[0].author || $[14] !== t4 || $[15] !== t8) {
    t9 = <NotificationHeader author={t3} actions={t4}>{t5}{t8}</NotificationHeader>;
    $[13] = notification.related_drops[0].author;
    $[14] = t4;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== notification.related_drops[0]) {
    t10 = {
      type: DropSize.FULL,
      ...notification.related_drops[0],
      stableKey: "",
      stableHash: ""
    };
    $[17] = notification.related_drops[0];
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== activeDrop || $[20] !== onDropContentClick || $[21] !== onQuote || $[22] !== onQuoteClick || $[23] !== onReply || $[24] !== onReplyClick || $[25] !== t10) {
    t11 = <Drop drop={t10} previousDrop={null} nextDrop={null} showWaveInfo={true} showReplyAndQuote={true} activeDrop={activeDrop} location={DropLocation.MY_STREAM} dropViewDropId={null} onReply={onReply} onQuote={onQuote} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} />;
    $[19] = activeDrop;
    $[20] = onDropContentClick;
    $[21] = onQuote;
    $[22] = onQuoteClick;
    $[23] = onReply;
    $[24] = onReplyClick;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t9) {
    t12 = <div className="tw-w-full tw-flex tw-flex-col tw-space-y-2">{t9}{t11}</div>;
    $[27] = t11;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}